


var initError = false;
var sumitting = false;
function reset () {
	setTimeout(function () {
		sumitting = false;
	}, window.errorInerval || 2000);
}
module.exports = function (projectName, url) {
	var oldError = window.onerror;

	if (initError) {
		return;
	}
	initError = true;
	window.onerror = function (msg, uri, row, col, err) {
		try {
			if (sumitting) {
				return;
			}
			sumitting = true;
			$.ajax({
				url: url || '/tool/error',
				type: 'POST',
				data: {
					project: projectName,
					msg: msg,
					uri: uri,
					row: row,
					col: typeof col === 'number' ? col : 0,
					stack: err ? err.stack : ''
				}
			}).done(function (res) {
				reset();
			}).fail(function (err) {
				reset();
				console.log(err);
			});

			if (oldError) {
				oldError.call(window, msg, uri, row, col, err);
			}
		} catch (err) {
			console.log(err);
			reset();
		}
	}
}


// WEBPACK FOOTER //
// ./~/fe-error-track/index.js